import axios from 'axios';
import BaseAPI from './base/base-api';

class SupplierAPI extends BaseAPI {
    constructor() {
        super();
    }
    urlName = 'InvoiceBotsAPI';
    controllerName = 'supplier';
}

export default new SupplierAPI();